export default __webpack_public_path__ + "static/media/user.78a3384d.svg";